import { Spinner } from 'reactstrap';
import { SelectInput } from '@/shared/ui';
import useChangeEventType from './useChangeEventType';

export type ChangeEventTypeProps = {
  selectedStrip: any;
  selectedMultipleStrip: any[];
  keyRecoil: string;
  onCancel: () => void;
  ecgDataMap: any;
  studyId: string;
  profileId: string;
  // pre-existing: modal/index.tsx's isShowChangeTypeBulk usage never passes this prop.
  timezoneOffset?: number;
};

/**
 * Renders the modal body letting a technician retype the selected ECG event. Shows a select populated with the change options the hook permits, a cancel button, and a save button that is disabled and shows a spinner while the change is in flight.
 *
 * @param props - The change event type props forwarded to the hook driving the select and the save action.
 * @returns The rendered change event type form with its cancel and save footer.
 */
const ChangeEventType = ({
  selectedStrip,
  selectedMultipleStrip,
  keyRecoil,
  onCancel,
  ecgDataMap,
  studyId,
  profileId,
  timezoneOffset,
}: ChangeEventTypeProps) => {
  const {
    state,
    isLoading,
    onChangeEvent,
    onClickCancel,
    onClickChangeEventType,
    getAvailableChangeEventTypeOptions,
  } = useChangeEventType({
    selectedStrip,
    selectedMultipleStrip,
    keyRecoil,
    onCancel,
    ecgDataMap,
    studyId,
    profileId,
    timezoneOffset,
  });

  return (
    <>
      <div className="draggable-modal-content">
        <div className="content-title">Change event type to</div>
        <div className="content">
          <SelectInput
            className="w-100 mb-3"
            name="eventType"
            ariaLabel="Event type"
            options={getAvailableChangeEventTypeOptions()}
            placeholder="Select event"
            value={state.eventType}
            onChange={onChangeEvent}
          />
        </div>
      </div>
      <div className="footer-btn">
        <button
          id="rh-event-cancel-change-event-type"
          className="draggable-modal-btn"
          onClick={() => {
            onClickCancel();
          }}
        >
          Cancel
        </button>
        <button
          id="rh-event-change-event-type"
          className="draggable-modal-btn btn-main"
          onClick={onClickChangeEventType}
          disabled={isLoading}
        >
          {isLoading && (
            // eslint-disable-next-line react/jsx-curly-brace-presence -- must be a literal empty string, not omitted: reactstrap's Spinner defaultProps falls back to children="Loading..." when children is undefined
            <Spinner className="mr-2">{''}</Spinner>
          )}
          Save
        </button>
      </div>
    </>
  );
};

export default ChangeEventType;
